import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { USERS_ALL } from 'api/query-keys.ts';
import type { UserRes } from 'api/swagger';

export const useGetAllUsers = ({ withBlocked = false } = {}) => {
  return useQuery<UserRes[]>({
    queryKey: [USERS_ALL, { withBlocked }],
    queryFn: async () => {
      const params = new URLSearchParams();

      if (withBlocked) {
        params.append('withBlocked', 'true');
      }
      const url = `/v1/users?${params.toString()}`;
      const { data } = await http.get<UserRes[]>(url);
      return data;
    },
    retry: 2,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    cacheTime: 60 * 1000,
  });
};
